// ==========================================
// Subscription Tiers
// ==========================================
export const TIERS = {
    FREE: "free",
    PRO: "pro",
};
// ==========================================
// Data Retention (days)
// ==========================================
export const DATA_RETENTION = {
    [TIERS.FREE]: 7,
    [TIERS.PRO]: 90,
};
// ==========================================
// Time Periods
// ==========================================
export const PERIODS = {
    "7d": 7,
    "30d": 30,
    "90d": 90,
};
// ==========================================
// Threads API
// ==========================================
export const THREADS_API_BASE = "https://graph.threads.net/v1.0";
export const THREADS_OAUTH_URL = "https://threads.net/oauth/authorize";
export const THREADS_SCOPES = [
    "threads_basic",
    "threads_manage_insights",
    "threads_read_replies",
];
export const THREADS_ACCOUNT_METRICS = [
    "views",
    "likes",
    "replies",
    "reposts",
    "quotes",
    "followers_count",
];
export const THREADS_POST_METRICS = [
    "views",
    "likes",
    "replies",
    "reposts",
    "quotes",
    "shares",
];
// ==========================================
// Sync
// ==========================================
export const SYNC_BATCH_SIZE = 50;
export const SYNC_MAX_CONSECUTIVE_ERRORS = 3;
export const MANUAL_SYNC_COOLDOWN = 300; // 5 minutes in seconds
export const TOKEN_REFRESH_DAYS_BEFORE_EXPIRY = 7;
// ==========================================
// Multi-account Limits
// ==========================================
export const ACCOUNT_LIMITS = {
    [TIERS.FREE]: 1,
    [TIERS.PRO]: 5,
};
//# sourceMappingURL=constants.js.map